import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ClubSelectField } from "./ClubSelectField";
import { ImageUploadField } from "./ImageUploadField";

export function NewsForm({ formData, f, managedClubs, api }) {
  return (
    <>
      <ClubSelectField formData={formData} f={f} managedClubs={managedClubs} />
      <div><Label className="text-sm">Titel</Label><Input value={formData.title || ""} onChange={e => f("title", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-title" /></div>
      <div><Label className="text-sm">Inhalt</Label><Textarea value={formData.content || ""} onChange={e => f("content", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" rows={5} data-testid="dialog-content" /></div>
      <ImageUploadField formData={formData} f={f} api={api} />
    </>
  );
}
